import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkLoggedUser, getUser } from '../../../redux/usersRedux';
import { useEffect } from 'react';
import {
  deleteBinRequest,
  loadBinsByWarehouseRequest,
  loadBinsRequest,
} from '../../../redux/binsRedux';
import { Box, Divider } from '@mui/material';

import BinSingleForm from '../../common/BinSingleForm/BinSingleForm';
import AddBin from '../AddBin/AddBin';
const BinList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const user = useSelector((state) => getUser(state));
  const bins = useSelector((state) => state.bins);
  useEffect(() => {
    const start = async () => {
      await dispatch(checkLoggedUser());
      if (user.users.role === 'ADMIN') {
        await dispatch(loadBinsRequest());
      } else if (user.users.role === 'KONTROLER') {
        await dispatch(loadBinsByWarehouseRequest(user.users.warehouse));
      }
    };
    start();
  }, [dispatch]);

  const handleSubmit = async (id) => {
    await dispatch(deleteBinRequest(id));
  };

  return (
    <Box>
      <AddBin />
      <Divider sx={{ mt: 5 }} />
      {bins.length > 0 && (
        <BinSingleForm
          action={handleSubmit}
          props={bins}
          text={t('bins.name')}
          link="edit-bin"
        />
      )}
    </Box>
  );
};

export default BinList;
